import React, { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import PageMenu from 'components/blocks/PageMenu/PageMenu'
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";
import { useParams } from 'react-router-dom';
import Loader from 'components/blocks/Loader/Loader';
import FormularioCertificadoEmpresa from './FormularioCertificadoEmpresa';
import useGetCertificadoEmpresaItByID from 'services/record/CertificadoEmpresa/useGetCertificadoEmpresaItByID';
import { jwtDecode } from 'jwt-decode';
import useDecode from 'hooks/useDecode';
interface Params {
    idprestacion: string;
    idform: string;
}


const HistorialFormularioCertificadoEmpresa = () => {
    const decoded = useDecode("token");
    const [data, setData] = useState(null);
    const navigate = useNavigate()
    const { getCertificadoEmpresaById,
        loadingGetCertificadoEmpresaById,
        dataGetCertificadoEmpresaById } = useGetCertificadoEmpresaItByID();
    const { idprestacion, idform } = useParams<Record<string, string>>();


    useEffect(() => {
        const actualUrl = window.location.href;
        if (!actualUrl.includes('/mis-gestiones/formularios')) {
            const userId = decoded.extension_id;
            const prestacionId = idprestacion.split('_')[1];
            const formId = idform;

            getCertificadoEmpresaById(userId, prestacionId, formId, setData);
        }
    }, []);

    return (
        <div>
            <PageMenu title={'Declaracion de Situacion de Actividad'}>

                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>


            {
                loadingGetCertificadoEmpresaById ?
                    <Loader activeLoader={true} label="Cargando Formulario"></Loader>
                    :
                    <FormularioCertificadoEmpresa dataUser={data} info={false} />
            }




        </div>
    )
}

export default HistorialFormularioCertificadoEmpresa